import { StorageKeys, CookiesKeys, StorageKeyPrefixes } from '@Engage.Data.Constants';
import { StorageService } from '../StorageService';
import { CookiesStorage, Errors, AppStates, MemoryStorage, addDays, isset, logService } from '@Engage.Core';
import { CookieOptions } from '@Engage.Data.Models';
import { localStorageService } from '../localStorage/LocalStorageService';
class CookiesStorageServiceClass extends StorageService {
    //#region Ctor
    constructor() {
        super();
        this.cookies = CookiesStorage.getInstance();
    }
    //#endregion
    //#region public 
    get(key, options) {
        options = this.extendOptions(options);
        // DebugSecurityService.addToDebug(DebugTypes.Cookies, key, "get", null, options, this);
        let expandedKey = key;
        if (options.expandKey) {
            expandedKey = this.expandKey(key);
        }
        if (!this.shouldUseRootDomain(options)) {
            expandedKey = StorageKeyPrefixes.Cookie + expandedKey;
        }
        return this.cookies.get(expandedKey);
    }
    set(key, value, options) {
        options = this.extendOptions(options);
        // DebugSecurityService.addToDebug(DebugTypes.Cookies, key, "set", value, options, this);
        let expandedKey = key;
        if (options.expandKey !== false) {
            expandedKey = this.expandKey(key);
        }
        if (options.daysOfLife) {
            options.expires = addDays(options.daysOfLife);
        }
        if (this.shouldUseRootDomain(options)) {
            options.domain = this.getRootDomain();
        }
        else {
            expandedKey = StorageKeyPrefixes.Cookie + expandedKey;
            options.domain = window.location.hostname;
        }
        try {
            this.cookies.set(expandedKey, value, options, options.converter);
        }
        catch (ex) {
            throw console.error(Errors.LOAD_ERRORS.cookie);
        }
    }
    delete(key, options) {
        options = this.extendOptions(options);
        let expandedKey = key;
        if (options.expandKey !== false) {
            expandedKey = this.expandKey(key);
        }
        if (this.shouldUseRootDomain(options)) {
            options.domain = this.getRootDomain();
        }
        else {
            expandedKey = StorageKeyPrefixes.Cookie + expandedKey;
            options.domain = window.location.hostname;
        }
        this.cookies.delete(expandedKey, options);
    }
    clear() {
        this.cookies.clear();
    }
    keys() {
        const aKeys = document.cookie
            .replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "")
            .split(/\s*(?:\=[^;]*)?;\s*/);
        return aKeys.map(decodeURIComponent);
    }
    // public getAllConnextRecords(): StorageRecordModel[] {
    //     let records: StorageRecordModel[] = [];
    //     let existingStorageKeys = this.getConnextExistingStorageKeys();
    //     each(existingStorageKeys, (storageKey) => {
    //         records.push({
    //             Name: storageKey,
    //             Value: this.get(storageKey, { expandKey: false, useRootDomain: true})
    //         });
    //     });
    //     return records;
    // }
    getConnextExistingStorageKeys(isCheckAllKeys = true) {
        let existingStorageKeys = this.keys();
        let constantStorageKeys = isCheckAllKeys ? this.getAllConstantKeys() : this.getStorageConstantKeys();
        constantStorageKeys = this.removeExceptionsFromKeys(constantStorageKeys);
        existingStorageKeys = this.filterConnextExistingStorageKeys(existingStorageKeys, constantStorageKeys);
        return existingStorageKeys;
    }
    getStorageConstantKeys() {
        return this.getConstantKeys(CookiesKeys);
    }
    getAllConstantKeys() {
        return this.getStorageConstantKeys().concat(localStorageService.getStorageConstantKeys());
    }
    //#endregion
    //#region private
    getNonEncryptValue(key, value, options) {
        try {
            const cookObj = JSON.parse(value);
            this.set(key, cookObj, options);
            return value;
        }
        catch (error) {
            return null;
        }
    }
    getRootDomain() {
        let rootDomain = '';
        let hostSegments = window.location.hostname.split('.');
        let domainSegmentsCount = 2;
        logService.log(`rootDomain getRootDomain hostSegments: ${hostSegments} cachedRootDomain: ${this.cachedRootDomain}`);
        // if localhost
        if (hostSegments.length < domainSegmentsCount) {
            return window.location.hostname;
        }
        if (this.cachedRootDomain) {
            return this.cachedRootDomain;
        }
        do {
            rootDomain = '.' + hostSegments.slice(-domainSegmentsCount).join('.');
            logService.log(`rootDomain getRootDomain rootDomain: ${rootDomain}`);
        } while (!this.checkWriteDomainCookie(rootDomain) && domainSegmentsCount++ < hostSegments.length);
        this.cachedRootDomain = rootDomain;
        return rootDomain;
    }
    checkWriteDomainCookie(domain) {
        let cookieKey = StorageKeys.ConnextCheckDomainWrite;
        let result = false;
        const options = {
            domain: domain,
            useMemoryFallback: false
        };
        this.cookies.set(cookieKey, 'Done!', options);
        result = !!this.cookies.get(cookieKey);
        this.cookies.delete(cookieKey, { domain: domain });
        logService.log(`rootDomain checkWriteDomainCookie domain: ${domain} result: ${result}`);
        return result;
    }
    shouldUseRootDomain(options) {
        if (isset(options.useRootDomain)) {
            return options.useRootDomain;
        }
        else {
            return MemoryStorage.get(AppStates.UseRootDomain);
        }
    }
    extendOptions(options) {
        return Object.assign(new CookieOptions(), options);
    }
}
export const CookiesStorageService = new CookiesStorageServiceClass();
